import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selectWrapper', 'inputWrapper', 'button', 'hidden'];

  toggle() {
    const showingSelect = this.hiddenTarget.value === 'select';

    if (showingSelect) {
      this.hiddenTarget.value = 'input';
      this.selectWrapperTarget.classList.add('d-none');
      this.inputWrapperTarget.classList.remove('d-none');
      this.buttonTarget.textContent = 'Cancel';
    } else {
      this.hiddenTarget.value = 'select';
      this.selectWrapperTarget.classList.remove('d-none');
      this.inputWrapperTarget.classList.add('d-none');
      this.buttonTarget.textContent = 'Create';
    }
  }
}
